export default data => ({
  chart: {
    zoomType: "xy",
    width: data.chartWidth,
    height: data.chartHeight
  },
  title: {
    text: data.chartTitle
  },
  subtitle: {
    text: data.chartSubTitle && data.chartSubTitle
  },
  series: data.series,
  tooltip: {
    shared: true,
    split: false
  },
  yAxis: {
    title: {
      text: data.yAxisLabel
    }
  },
  xAxis: {
    title: {
      text: data.xAxisLabel
    }
  },
  legend: {
    enabled: true,
    // layout: 'vertical',
    // align: 'left',
    // x: 120,
    verticalAlign: "top",
    y: 40
    // floating: true,
    // backgroundColor: '#FFFFFF'
  },
  rangeSelector: {
    enabled: false
  }
});



// WEBPACK FOOTER //
// ./src/views/reports/report_chart/chart/chart.config.js